import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAMQ3sTzW3wIcpV_GjU2kCNQFY87WmzbsU",
  authDomain: "sugar-crib.firebaseapp.com",
  projectId: "sugar-crib",
  storageBucket: "sugar-crib.firebasestorage.app",
  messagingSenderId: "556246658472",
  appId: "1:556246658472:web:e12463dbae67258fed819d",
  measurementId: "G-CJPVGNYSDX",
};

const app = initializeApp(firebaseConfig);

// Firebase App Check with reCAPTCHA v3
try {
  if (typeof window !== "undefined") {
    // Use provided reCAPTCHA v3 site key
    // const siteKey = process.env.REACT_APP_RECAPTCHA_V3_SECRET_KEY;

    // Enable debug token for development
    // if (process.env.NODE_ENV !== "production") {
    //   // eslint-disable-next-line no-underscore-dangle
    //   console.log("Add this debug token to your Firebase Console > App Check > Apps > [your-app] > Debug tokens");
    // }

    // initializeAppCheck(app, {
    //   provider: new ReCaptchaV3Provider(siteKey),
    //   isTokenAutoRefreshEnabled: true,
    // });

    // console.log("Firebase App Check initialized with reCAPTCHA v3");
  }
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn("Firebase App Check initialization failed:", e);
}
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Initialize analytics only if supported and consent is given
let analytics = null;
const initializeFirebaseAnalytics = async () => {
  if (typeof window !== 'undefined' && await isSupported()) {
    try {
      analytics = getAnalytics(app);
      return analytics;
    } catch (error) {
      console.warn('Firebase Analytics initialization failed:', error);
      return null;
    }
  }
  return null;
};

export { auth, provider, analytics, initializeFirebaseAnalytics };
